const STORAGE_KEY = 'sitePassword';
let hasChecked = false; // Flag to prevent multiple executions

/**
 * Display error message and block access
 * @param message Error message
 */
function showAccessDenied(message: string): void {
  document.documentElement.innerHTML =
    '<html><head><meta charset="UTF-8"></head><body><h1 style="text-align:center;margin-top:100px;font-family:sans-serif;">' +
    message +
    '</h1></body></html>';
  throw new Error('Access denied');
}

/**
 * Generate today's password (link + MMDD format)
 * @returns Today's password
 */
function generateTodayPassword(): string {
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const date = String(today.getDate()).padStart(2, '0');
  return 'link' + month + date;
}

/**
 * Add site password verification
 * @param enabled Whether to enable password verification
 */
export const addSitePassword = (enabled: boolean): void => {
  // Prevent multiple executions
  if (hasChecked) {
    return;
  }
  hasChecked = true;

  if (!enabled) {
    return;
  }

  const correctPassword = generateTodayPassword();
  const storedPassword = localStorage.getItem(STORAGE_KEY);

  // If stored password matches today's password, allow access
  if (storedPassword === correctPassword) {
    return;
  }

  // If stored password is incorrect (possibly expired), remove it
  if (storedPassword) {
    localStorage.removeItem(STORAGE_KEY);
  }

  // Prompt user to enter password
  const userInput = prompt('アクセスパスワードを入力してください:');

  if (userInput === null) {
    // User cancelled input
    showAccessDenied('このページへのアクセスには認証が必要です');
  } else if (userInput === correctPassword) {
    // Password correct, save to localStorage
    localStorage.setItem(STORAGE_KEY, correctPassword);
  } else {
    // Password incorrect
    showAccessDenied('パスワードが正しくありません');
  }
};
